var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"iconCheck",class:_vm.themeModel.theme,attrs:{"width":"9","height":"6","viewBox":"0 0 9 6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.54014 1.09961L3.51481 5.10744L1.09961 2.69224","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }